/**
 * 获取 API 基础 URL（不包含 /api）
 */
export function getApiBaseUrl(): string {
  if (typeof window !== 'undefined') {
    // 客户端：使用环境变量或默认值
    const apiUrl = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3000/api';
    return apiUrl.replace('/api', '');
  }
  // 服务端：使用环境变量或默认值
  return (process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3000/api').replace('/api', '');
}

/**
 * 构造图片完整 URL
 */
export function getImageUrl(imagePath?: string | null): string {
  if (!imagePath || typeof imagePath !== 'string' || imagePath.trim() === '') {
    return '/placeholder-case.jpg';
  }
  
  const trimmedPath = imagePath.trim();
  
  // 如果已经是完整 URL，直接返回（仅在客户端验证）
  if (trimmedPath.startsWith('http://') || trimmedPath.startsWith('https://')) {
    if (typeof window !== 'undefined') {
      try {
        // 仅在客户端验证 URL
        new URL(trimmedPath);
        return trimmedPath;
      } catch {
        // 如果 URL 无效，返回占位符
        return '/placeholder-case.jpg';
      }
    }
    return trimmedPath;
  }
  
  // 确保路径以 / 开头
  const normalizedPath = trimmedPath.startsWith('/') ? trimmedPath : `/${trimmedPath}`;
  const baseUrl = getApiBaseUrl();
  
  // 确保 baseUrl 有效
  if (!baseUrl || baseUrl.trim() === '') {
    return normalizedPath;
  }
  
  // 构造完整 URL
  const fullUrl = `${baseUrl}${normalizedPath}`;
  
  // 仅在客户端验证完整 URL
  if (typeof window !== 'undefined') {
    try {
      new URL(fullUrl);
      return fullUrl;
    } catch {
      // 如果构造失败，返回相对路径
      return normalizedPath;
    }
  }
  
  // 服务端直接返回完整 URL
  return fullUrl;
}

